export const jobData = {
	stickK: [
		{
			title: "Software Engineer",
			years: "February 2023 - Present",
			link: "https://www.stickk.com/",
			bullets: [
				"Updated 30+ of the company's legacy API endpoints to improve performance and reduce technical debt",
				"Implemented new features for a large-scale enterprise client, including a custom admin dashboards and new API endpoints",
				"Improved internal API documentation by writing 10+ pages of documentation and linking it to development endpoints in Postman",
				"Initiated and led a company-wide effort to leverage AI to improve the user experience as well as internal systems",
			],
		},
		{
			title: "Product Manager",
			years: "July 2018 - October 2020",
			link: "https://www.stickk.com/",
			bullets: [
				"Led the design and implementation of a new revenue stream: a low-cost, self-serve subscription service for small groups that scaled to 1,000+ groups in the first 6 months",
				"Manage product lifecycle of B2B and B2C platforms (web, iOS, and Android); including engaging with users and clients to identify needs, defining technical specs, planning development sprints, organizing production releases, and monitoring end user feedback",
				"Increased company-wide access to user behavior data by building out an internal data dashboard to track key platform metrics",
				"Onboarded and collaborated with multiple clients ranging from municipalities to Fortune 500 companies to ensure the delivery of high-quality, customized wellness solutions on our white-labeled B2B platform",
			],
		},
		{
			title: "Associate Product Manager",
			years: "May 2017 - July 2018",
			link: "https://www.stickk.com/",
			bullets: [
				"Developed user stories, user flows, and feature requirements—evaluated their potential by analyzing market and customer needs",
				"Managed the product backlog, worked day-to-day with the product Scrum teams to clarify requirements and recommend alternative approaches to meet design and technical requirements",
				"Reduced support inquiries by 35% by spearheading efforts and contributing code (HTML/CSS) to re-design a text-only FAQ page into a dynamic Help Center, allowing users to more easily locate information before contacting our support team",
			],
		},
	],
	Meetup: [
		{
			title: "Senior Community Experience Specialist",
			years: "November 2016 - May 2017",
			link: "https://www.meetup.com/",
			bullets: [
				"Specialized as a technical troubleshooter to document bug respots and negotiate prioritization with product teams",
				"Performed manual product troubleshooting across desktop web, mobile web, native iOS app, and native Android app platforms",
				"Created internal training resources for the 30+ person Community Experience team to improve troubleshooting efficiency",
				"Assisted with quality assurance testing the entire web platform during the company’s migration into the cloud",
			],
		},
		{
			title: "Community Experience Specialist",
			years: "September 2014 - November 2016",
			link: "https://www.meetup.com/",
			bullets: [
				"Sent over 27,000 support emails to Meetup users to provide technical support across all platforms",
				"Began troubleshooting as one of three team members focused on resolving user-reported technical issues",
				"Created and published original Twitter content for the main Meetup account and provided support on the Meetup support account",
			],
		},
	],
};
